import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  EditLocationModalContainer, type EditLocationModalContainerProps,
} from './editLocationModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    EditLocationData: EditLocationModalContainerProps;
  }
}
modalRenderer.register('EditLocationData', EditLocationModalContainer);
